var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mb_header__menu_ul"},[_vm._t("menu",null,{"clickOpen":_vm.isOpen,"toggleProps":_vm.toggle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }